module.exports = __webpack_public_path__ + "img/loan-wallet.9e7b0bad.svg";